import { sortBy } from 'lodash';
import { RootState } from '..';

export const selectParameterGroups = (state: RootState) =>
  sortBy(state.parameterGroups.parameterGroups, 'name');

export const selectParameterGroupErrors = (state: RootState) =>
  state.parameterGroups.errors;
